var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('AboutMembersHeader'),_c('AboutMembersIntro'),_vm._l((_vm.groups),function(group,i){return _c('AboutMembersIndex',{key:group.title,attrs:{"group":group,"is-first":!i}})}),_c('AboutMembersMore'),_c('AboutMembersCta')],2)}
var staticRenderFns = []

export { render, staticRenderFns }